module.exports = __webpack_public_path__ + "static/nezam-senfi-fd825cc4ed862e6c16abf9837d171947.png";